import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RouteHelperService {

  constructor() { }

  /**
   * Get the correct MyParking route path based on deployment configuration
   * @param path - The path without the myparking prefix (e.g., 'login', 'dashboard', etc.)
   * @returns The full route path
   */
  getMyParkingRoute(path: string = ''): string {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    
    if (environment.isMyParkingDeployment) {
      // When deployed as MyParking app, routes are at root level
      return `/${cleanPath}`;
    } else {
      // When not deployed as MyParking app, routes are under /myparking prefix
      return `/myparking/${cleanPath}`;
    }
  }

  /**
   * Get the MyParking root route
   * @returns The root route for MyParking
   */
  getMyParkingRoot(): string {
    return this.getMyParkingRoute('');
  }

  /**
   * Get common MyParking routes
   */
  getRoutes() {
    return {
      root: this.getMyParkingRoute(''),
      login: this.getMyParkingRoute('login'),
      auth: this.getMyParkingRoute('login'), // alias for login
      verifyOtp: this.getMyParkingRoute('verify-otp'),
      dashboard: this.getMyParkingRoute('dashboard'),
      vehicleRegistration: this.getMyParkingRoute('vehicle-registration'),
      paymentSuccess: this.getMyParkingRoute('payment-status/success'),
      paymentFailure: this.getMyParkingRoute('payment-status/failure'),
      paymentCancel: this.getMyParkingRoute('payment-status/cancel')
    };
  }
}